/**
 * SampleLibraryButton Component
 * Button to open Sample Library panel
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Library } from 'lucide-react';

export const SampleLibraryButton = ({ setShowSampleLibrary }) => (
  <Button
    variant="ghost"
    size="sm"
    onClick={() => setShowSampleLibrary(true)}
    className="relative p-2 text-zinc-400 hover:text-white hover:bg-emerald-500/20"
    data-testid="sample-library-btn"
    title="Sample Library"
  >
    <Library className="w-5 h-5" />
  </Button>
);

export default SampleLibraryButton;
